import { render } from "./UserBadge.html?vue&type=template&id=893a1ca8&ts=true&external"
import script from "./UserBadge.vue?vue&type=script&lang=ts"
export * from "./UserBadge.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__